import React, { Fragment } from 'react';
import { useQuery } from '@apollo/client';
import { LAUNCHES_QUERY } from '../lib/queries';
import LaunchItem from './LaunchItem';
import MissionKey from './MissionKey';

export default function Launches() {

    const { loading, error, data } = useQuery(LAUNCHES_QUERY);
    console.log(data);

    if (loading) return (
        <Fragment>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
        </Fragment>
    );

    if (error) return `Error! ${error.message}`;

    return (

        <Fragment>
            <h1 className="display-4 my-3">Launches</h1>
            <MissionKey />
            <Fragment>
                {data.launches.map(launch => (
                    <LaunchItem key={launch.id} launch={launch} />
                ))}
            </Fragment>

        </Fragment>
    )
};